<template>
  <div class="dropdown" v-click-outside="hideDropdown" :class="[ show ? 'dropdown--active' : '', extraCssClass ]" v-cloak>
    <a class="dropdown__link link--no-hover" @click="toggleDropdown()">
      <span class="dropdown__selected">{{ selectedText }}</span>
      <i class="icon " :class="[ show ? 'icon--flipped' : '', iconClass ]"></i>
    </a>
    <input type="hidden" :name="hiddenFieldName" :id="hiddenFieldName" ref="dropdownType" :value="selectedOptionId">
    <transition name="fade">
      <div class="dropdown__holder" v-if="show" v-cloak>
        <ul class="dropdown__list">
          <li
            v-for="option in displayOptions"
            class="dropdown__list-item"
            :class="{ 'dropdown__list-item--active': selectedOptionId === option.key }"
          >
            <a class="dropdown__list-link" @click="selectOption(option.key)">
              {{ option.value }}
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script setup>
import {ref, computed, onMounted} from 'vue';

// Props
const props = defineProps({
  emptyString: {
    default: '',
  },
  defaultSelectedId: {
    default: '',
  },
  options: {
    default: [],
  },
  iconClass: {
    default: 'icon--down',
  },
  extraCssClass: String,
  submitForm: {
    type: Boolean,
    default: false,
  },
  hiddenFieldName: {
    type: String,
    default: 'dropdownType',
  },
  hideEmptyString: {
    type: Boolean,
    default: false,
  }
});

// Data
let show = ref(false);
let selectedOptionId = ref(props.defaultSelectedId);

// Refs
const dropdownType = ref(null);

// Computed
const selectedText = computed(() => {
  const selected = props.options.find(opt => opt.key === selectedOptionId.value);
  return selected ? selected.value : props.emptyString;
});

const displayOptions = computed(() => {
  if (props.emptyString && !props.hideEmptyString) {
    props.options.unshift({ key: 0, value: props.emptyString });
  }
  return props.options;
});

// Methods
const toggleDropdown = () => {
  show.value = !show.value;
};

const hideDropdown = () => {
  if (show.value) {
    show.value = false;
  }
};

const selectOption = (key) => {
  selectedOptionId.value = key;
  show.value = !show.value;
  const selected = props.options.find(opt => opt.key === selectedOptionId.value);
  dropdownType.value.value = selected.key;

  if (props.submitForm) {
    const form = dropdownType.value.closest('form');
    form.submit();
  }
};


// Lifecycle
onMounted(() => {
  if (selectedOptionId.value !== 0) {
    const selected = props.options.find(opt => opt.key === selectedOptionId.value);
    dropdownType.value = selected.key;
  }
});
</script>
